import React, { useContext, useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import './CertiDetails.scss';
import MyContext from '../../../Uttis/MyContext';

const CertiDetails = () => {
  const {setMessage,setSnack,setLoading,url}= useContext(MyContext);

const[certiDetails, setCertiDetails] =useState(null)

  const formik = useFormik({
    initialValues: {
      certiid: '',
    },
    validationSchema: yup.object({
      certiid: yup.string('Enter your certiid').required('Certification ID is required'),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = await fetch(`${url}/certi-details`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ certiid: values.certiid }),
        });
        const data = await response.json();
        if (data.success) {
          setCertiDetails(data.data);
        } else {
          console.error("Error fetching certificate details:", data.message);
          setSnack(true);
          setMessage(data.message);
          
          
        }
      } catch (error) {
        console.error(error);

      } finally {
        setLoading(false);
      }
    },
  });

  return (
   
   
     
          <div className="certi-details-form">
            <h1>Certificate Details</h1>
            <form onSubmit={formik.handleSubmit}>
              <div className="form-group">
                <TextField
                  id="certiid"
                  name="certiid"
                  value={formik.values.certiid}
                  onChange={formik.handleChange}
                  error={formik.touched.certiid && Boolean(formik.errors.certiid)}
                  helperText={formik.touched.certiid && formik.errors.certiid}
                  label="Certification ID"
                  variant="standard"
                  fullWidth
                />
              </div>
              <Button variant="contained" type="submit" fullWidth>
                Submit
              </Button>
            </form>

            {certiDetails && (
              <div className="certi-details-info">
                <h2>Certificate Details</h2>
                <p><strong>Name:</strong> {certiDetails.name}</p>
                
                <p>{certiDetails.work}</p>
              </div>
            )}
          </div>
      
      
    
  );
};

export default CertiDetails;
